<template lang="pug">
  b-card.draggable-component.text-center
    div(v-if="isDialing")
      div
        p Llamar a
        div.d-flex
          vue-country-code(
            @onSelect="onSelect",
            :enabledCountryCode="true",
            :preferredCountries="['mx', 'us', 'ca', 'co', 'pe', 'br']"
          )
          b-form-input.input(
            placeholder="Número",
            v-model="number",
            :pattern="allowedCharacters",
            @keydown="validateInput"
          )
      div.mb-2.d-flex.justify-content-between.flex-wrap
        b-button.buttonStyle.m-2.justify-content-center(
          variant="soft-secondary",
          v-for="(key, index) in keys",
          :key="index",
          @click="putNumber(key)"
        ) {{ key }}
      div.d-flex.justify-content-end
        b-button.buttonStyle.m-2(
          @click="makeACall()",
          style="background-color: #52B366"
        )
          phone-icon(fill="white", stroke="none").icon-sm
        div.ml-3
          b-button.buttonStyle.m-2(
            @click="deleteNumber()",
            style="background-color: transparent; .border:active, .border:focus { outline: none; box-shadow: none; }"
          )
            delete-icon(fill="white", stroke="black").icon-lg
    div.d-flex.justify-content-center.flex-column.margin(v-if="!isDialing")
      div
        p.mb-0 Llamando a
        p {{ number }}
      div.d-flex.justify-content-center
        p(v-if="isCalling") {{ counter }}
        b-avatar.mb-4.pulser(v-if="!isCalling", style="background-color: #52B366")
          phone-icon(fill="white", stroke="none").icon-sm
      div.d-flex.justify-content-center
        b-button.m-2.buttonStyle(@click="mute", :style="{ backgroundColor: '#E2E6ED' }")
          mic-icon(v-if="!isMuted").icon-sm(stroke='#000000', fill='none')
          mic-off-icon(v-if="isMuted").icon-sm(stroke='#000000', fill='none')
        b-button.m-2(v-if="canRedirect", @click="isToForward = true", :style="{ backgroundColor: '#E2E6ED' }").buttonStyle
          phone-forwarded-icon.icon-sm(stroke='#000000', fill='none')
        b-button.m-2.buttonStyle(
          :disabled="canCancelCall",
          @click="disconnect",
          :style="{ backgroundColor: '#FF4D4F' }"
        )
          x-icon.icon-sm(stroke='white', fill='white')
    b-modal(
      size="md",
      button-size="sm",
      v-model="isToForward",
      cancel-title="Cancelar",
      cancel-variant="transparent",
      ok-title="Transferir",
      ok-variant="primary",
      hide-header-close,
      @ok="callForwarded"
    )
      template(#modal-header)
        b-row(align-v="center").mx-auto
          b-col(align-self="center").text-center
            p.mb-1 Transferir llamada
            b-avatar(@click="isToForward = true", style="background-color: #E2E6ED").buttonStyle
              phone-forwarded-icon.icon-sm(stroke='#000000', fill='black')
      div
        b-input-group(size="sm")
          b-form-input(type="search", placeholder="Buscar agente", @input="findAgent($event)")
          b-input-group-append
            b-input-group-text
              search-icon.text-dark.icon-sm
        hr
        b-tabs(small, nav-class="flex-nowrap scrollable-area overflow-hidden overflow-x pb-1")
          b-tab(
            v-for="(name, index) of groupsName",
            :key="index",
            :title="name"
          ).scrollable-area.overflow-x
            b-form-group
              b-table(
                :fields="agentsFields",
                :items="sortAgentsInGroups(name)",
                hover,
                selectable,
                responsive,
                show-empty,
                sticky-header,
                select-mode="single",
                thead-tr-class="d-none",
                @row-selected="agentSelected",
              ).m-0.overflow-y.scrollable-area.text-center
                template(#empty)
                  p.mb-0.text-help No hay agentes para mostrar
                template(#cell(image)="row")
                  div.d-flex.justify-content-center.align-items-center
                    b-avatar(v-if="row.item.image", :src="row.item.image", :text="row.item.image", variant="soft-secondary").mr-3
                template(#cell(fullName)="row")
                  div.d-flex.flex-column.justify-content-center.align-items-start
                    span {{ row.item.fullName.name }}
                    span.text-secondary.text {{ row.item.fullName.email }}
                template(#cell(status)="row")
                  div.d-flex.justify-content-center.align-items-center
                    b-badge(pill :variant="getStatusColor(row.item.status)") {{ row.item.status }}
</template>

<script>
import { Caller } from '../helpers/caller'
import { createNamespacedHelpers, mapActions } from 'vuex'

const accountController = createNamespacedHelpers('account')

export default {
  data: () => {
    return {
      fromNumber: '',
      canRedirect: false,
      groupsName: [],
      agentsFields: ['image', 'fullName', 'status'],
      groupsToFilter: [],
      agents: [],
      getAgents: [],
      allowedCharacters: '^[0-9*#]+$',
      keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
      call: null,
      number: '',
      isDialing: true,
      isMuted: false,
      caller: null,
      totalSeconds: 0,
      intervalId: null,
      isToForward: false,
      redirectTo: '',
      isCalling: false,
      canCancelCall: false,
      internationalNumber: ''
    }
  },
  props: {
    device: {
      type: Object,
      default: () => {
        return {}
      }
    },
    token: {
      type: String,
      default: ''
    }
  },
  computed: {
    counter() {
      const hours = Math.floor(this.totalSeconds / 3600)
      const minutes = Math.floor((this.totalSeconds % 3600) / 60)
      const seconds = this.totalSeconds % 60

      const formattedHours = this.padNumber(hours)
      const formattedMinutes = this.padNumber(minutes)
      const formattedSeconds = this.padNumber(seconds)

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    ...accountController.mapGetters([
      'getFromNumber'
    ]),
  },
  methods: {
    ...mapActions(['account/getAdminAgents']),
    async callForwarded(event) {
      event.preventDefault()

      if (!this.call.parameters.CallSid || !this.redirectTo) {
        return this.$message.error('No se puede transferir la llamada')
      }

      const params = {
        callId: this.call.parameters.CallSid,
        email: this.redirectTo
      }

      this.getAdminAgents()
      await this.caller.redirectCall(params)
    },
    agentSelected(items) {
      if (!items || !items[0] || !items[0].fullName) return

      this.redirectTo = items[0].fullName.email
    },
    getStatusColor(status) {
      const color = {
        Disponible: 'success',
        'No estatus': 'soft-secondary',
        offline: 'soft-danger'
      }[status]

      return color
    },
    sortAgentsInGroups(name) {
      if (name === 'Todos') return this.getAgents

      const filteredAgents = this.getAgents.filter((admin) => {
        const group = this.groupsToFilter.find((group) => group.name === name)

        if (group && group.admins.includes(admin.adminId)) return true

        return false
      })

      return filteredAgents
    },
    findAgent(agentToFind) {
      if (agentToFind) {
        const agentsFound = this.agents.filter(({ fullName }) => {
          const agentNameLowerCase = fullName.name.toLowerCase()
          const agentToFindLowerCase = agentToFind.toLowerCase()

          return agentNameLowerCase.startsWith(agentToFindLowerCase)
        })

        if (!agentsFound.length) {
          this.getAgents = []
          return
        }

        this.getAgents = JSON.parse(JSON.stringify(agentsFound))
      } else {
        this.getAgents = this.agents
      }
    },
    startCounter() {
      this.intervalId = setInterval(() => {
        this.totalSeconds++
      }, 1000)
    },
    stopCounter() {
      this.totalSeconds = 0

      clearInterval(this.intervalId)
    },
    padNumber(value) {
      return value.toString().padStart(2, '0')
    },
    onSelect({ dialCode }) {
      this.internationalNumber = `+${dialCode}`
    },
    validateInput(event) {
      const allowedKeys = [8, 46, 37, 39]
      const allowedChars = ['*', '#']
      const keyCode = event.keyCode || event.which
      const keyChar = String.fromCharCode(keyCode)

      if (
        (keyCode >= 48 && keyCode <= 57) ||
        allowedKeys.includes(keyCode) ||
        allowedChars.includes(keyChar)
      ) {
        return true
      } else {
        event.preventDefault()

        return false
      }
    },
    putNumber(number = '') {
      if (this.number.length === 13) {
        this.number = this.number.slice(0, 13)

        return this.number
      }

      this.number += number
    },
    deleteNumber() {
      if (this.number.toString().length !== 0) this.number = this.number.slice(0, -1)
    },
    async makeACall() {
      this.isDialing = false
      this.canCancelCall = true

      const finalNumber = this.internationalNumber + this.number

      if (
        !finalNumber ||
        finalNumber.toString().length < 5 ||
        !this.caller
      ) {
        this.isDialing = true

        return
      }

      this.caller.call(finalNumber, this.token)

      setTimeout(() => {
        this.canCancelCall = false
      }, 9000)
    },
    disconnect() {
      this.totalSeconds = 0

      clearInterval(this.intervalId)

      const params = { callId: this.call.parameters.CallSid }

      this.call.disconnect()

      if (this.caller) this.caller.deleteCall(params).then()

      this.isDialing = true
    },
    mute() {
      this.isMuted = !this.isMuted

      return this.call.mute(this.isMuted)
    },
    getAdminAgents() {
      this['account/getAdminAgents']({
        accountId: this.$route.params.account_id,
        callback: (res) => {
          if (res.error) return this.$message.error(res.error)

          this.groupsToFilter = Object.values(res.resource.groups)
          this.agents = res.resource.admins.map(({
            admin_id: adminId,
            image,
            first_name: firstName,
            last_name: lastName,
            email,
            status
          }) => {
            return {
              adminId,
              image: image || firstName.charAt(0),
              fullName: {
                name: `${firstName} ${lastName}` || 'Sin nombre',
                email: email || 'Sin email'
              },
              status: (status === 'default' || !status) ? 'No estatus' : status
            }
          })

          this.groupsName = Object.values(res.resource.groups)
            .map(group => group.name)

          this.groupsName.unshift('Todos')

          this.getAgents = this.agents
        }
      })
    },
  },
  mounted() {
    this.caller = new Caller(this)
    this.getAgents = this.agents

    this.getAdminAgents()
  },
  watch: {
    isToForward() {
      this.getAdminAgents()
    },
    isCalling() {
      if (this.isCalling) {
        setTimeout(() => {
          this.canRedirect = true
        }, 20000)
      } else {
        this.canRedirect = false
      }
    },
    internationalNumber(value) {
      console.log(value)
    }
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
.platform-tabs-flex {
  display: flex;
  flex-wrap: nowrap !important;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}
.margin {
  margin-top: 70px;
}
.input {
  border: none;
  font-weight: bold;
  color: black;
}
.buttonStyle {
  border-radius: 200px;
  height: 40px;
  width: 40px;
  border: none;
}
.draggable-component {
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  width: 250px;
  max-width: 250px;
  height: 400px;
  max-height: 400px;
  background-color: #FFFFFF;
  position: absolute;
  top: 22px;
  border-radius: 10px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
}

.pulser {
  animation: pulse 0.4s infinite alternate;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
</style>
